import type { EntitlementDecision } from '@tabbio/types';

type AiCreditLimitDecision = Omit<
  Partial<
    Pick<
      EntitlementDecision,
      | 'reasonCode'
      | 'remainingActionsToday'
      | 'customerAllowance'
    >
  >,
  'reasonCode'
> & {
  reasonCode?: string | null;
};

type TranslationValues = {
  limit?: number;
};

export type AiCreditLimitBanner = {
  visible: boolean;
  titleKey: string;
  hintKey: string;
  values: TranslationValues;
};

export const HIDDEN_AI_CREDIT_LIMIT_BANNER: AiCreditLimitBanner = {
  visible: false,
  titleKey: 'chat.aiLimitReached',
  hintKey: 'chat.aiLimitReachedHint',
  values: {},
};

export function selectAiCreditLimitBanner(
  decision: AiCreditLimitDecision | null | undefined,
  canProceed: boolean,
): AiCreditLimitBanner {
  if (
    canProceed ||
    !decision ||
    (decision.reasonCode !== 'action_allowance_reached' &&
      decision.reasonCode !== 'ai_daily_limit_reached' &&
      decision.reasonCode !== 'workspace_ai_limit_reached')
  ) {
    return HIDDEN_AI_CREDIT_LIMIT_BANNER;
  }

  const allowanceLimit = decision.customerAllowance?.limit;
  const isCustomerAllowance =
    decision.reasonCode === 'action_allowance_reached' &&
    typeof allowanceLimit === 'number';

  return {
    visible: true,
    titleKey:
      decision.reasonCode === 'workspace_ai_limit_reached'
        ? 'chat.aiWorkspaceLimitReached'
        : isCustomerAllowance
          ? 'chat.freeRepliesUsed'
        : 'chat.aiLimitReached',
    hintKey: isCustomerAllowance
      ? 'chat.freeRepliesResetHint'
      : 'chat.aiLimitReachedHint',
    values: isCustomerAllowance ? { limit: allowanceLimit } : {},
  };
}
